import React, { useEffect, useState, useCallback } from 'react';
import { Item, Toolbar } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import DropDownButton from 'devextreme-react/drop-down-button';
import TabPanel, { Item as TabPanelItem } from 'devextreme-react/tab-panel';
import { ClubForm, } from '../../components';
import { withLoadPanel } from '../../utils/withLoadPanel';
import './club_edit.scss';
import ScrollView from 'devextreme-react/scroll-view';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { useNavigate, useParams } from 'react-router-dom';
import { getApiToken } from '../../utils/authUtils.js';
import notify from 'devextreme/ui/notify';
import { useMsal } from "@azure/msal-react";
const ClubFormWithLoadPanel = withLoadPanel(ClubForm);
export const ClubDetails = () => {
      const { instance, accounts } = useMsal();
    const [data, setData] = useState();
    const [clubData, setclubData] = useState({});

    const [trainingsgroupData, settrainingsgroupData] = useState([])
    const [notes, setNotes] = useState();
    const [messages, setMessages] = useState([]);
    const [activeOpportunities, setActiveOpportunities] = useState();
    const [closedOpportunities, setClosedOpportunities] = useState();
    const [isLoading, setIsLoading] = useState(false);

    let { clubId } = useParams()
    const navigate = useNavigate();

    const onLeftClick = () => {
        navigate(-1);
    };
    useEffect(() => {
        loadData();
    }, []);

    const loadData = useCallback(() => {

        getApiToken(instance, accounts).then(token => {
            const dataSource = createStore({
                key: 'clubId',
                loadUrl: `${process.env.REACT_APP_serverEndpoint}/Club/Clubs`,
                insertUrl: `${process.env.REACT_APP_serverEndpoint}/Club/InsertClub`,
                updateUrl: `${process.env.REACT_APP_serverEndpoint}/Club/UpdateClub`,
                deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Club/DeleteClub`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });
          


            Promise.all([
                dataSource.load({ filter: ['clubId', '=', clubId] }),
          


            ]).then((values) => { setData({ club: values[0][0] }); setIsLoading(false); }).catch((error) => console.log(error));


        });

    }, [getApiToken]);

    const refresh = useCallback(() => {
        setIsLoading(true);
        loadData();
    }, [loadData]);
    const onSave = useCallback((data) => {
        getApiToken(instance, accounts).then(token => {
            const dataSource = createStore({
                key: 'clubId',
                updateUrl: `${process.env.REACT_APP_serverEndpoint}/Club/UpdateClub`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });
            dataSource.update(data.clubId, data).then(() => {
                notify({
                    message: `Verein "${data.clubname}" gespeichert`,
                    position: { at: 'bottom center', my: 'bottom center' }
                },
                    'success'
                );
            }
            );
        })
    }, []);

    return (
        <ScrollView className='view-wrapper-scroll'>
            <div className='view-wrapper view-wrapper-club-details'>
                <Toolbar className='toolbar-details theme-dependent'>
                    <Item location='before'>
                        <Button icon='arrowleft' stylingMode='text' onClick={onLeftClick} />
                    </Item>
                    <Item location='before' text={function () {
                        if (!!data) {

                            return data?.club?.clubname
                        } else {
                            return 'Lädt...'
                        }

                    }} />
                    {/* <Item location='after' locateInMenu='auto'>
                        <Button
                            text='Terminate'
                            type='default'
                            stylingMode='contained'
                        />
                    </Item>
                    <Item location='after'>
                        <DropDownButton
                            text='Actions'
                            stylingMode='text'
                            dropDownOptions={{ width: 'auto' }}
                            items={['Assign to Me', 'Archive']}
                        />
                    </Item>
                    <Item location='after' locateInMenu='auto'>
                        <div className='separator' />
                    </Item>
                    <Item
                        location='after'
                        locateInMenu='auto'
                        widget='dxButton'
                        showText='inMenu'
                    >
                        <Button
                            text='Copy'
                            icon='copy'
                            stylingMode='text'
                        />
                    </Item>
                    <Item
                        location='after'
                        locateInMenu='auto'
                        widget='dxButton'
                        showText='inMenu'
                    >
                        <Button
                            text='Refresh'
                            icon='refresh'
                            stylingMode='text'
                            onClick={refresh}
                        />
                    </Item> */}
                </Toolbar>

                <div className='panels'>
                    <div className='left'>
                        <ClubFormWithLoadPanel
                            loading={isLoading}
                            hasData={!!data}
                            data={data}
                            onSave={onSave}
                        />
                    </div>


                </div>
            </div>
        </ScrollView>
    );
};
